import styled from "@emotion/styled";

import artistInResidence from "assets/images/badge_artist-in-residence.png";
import curatorPick from "assets/images/badge_curator-pick.png";
import groupHug2022 from "assets/images/badge_group-hug-2022.png";
import groupHugGrad from "assets/images/badge_group-hug-graduate.png";
import hedgeHug from "assets/images/badge_hedgehug.png";
import zenAcademy from "assets/images/badge_zenacademy.png";

interface Props {
  badges: string[];
}

const getBadgeImage = (badge: string) => {
  if (badge.match(/curator/i)) {
    return curatorPick;
  }
  if (badge.match(/hedge/i)) {
    return hedgeHug;
  }
  if (badge.match(/2022/i)) {
    return groupHug2022;
  }
  if (badge.match(/grad/i)) {
    return groupHugGrad;
  }
  if (badge.match(/ZenAcademy/i)) {
    return zenAcademy;
  }
  if (badge.match(/HUG Artist-In-Residence/i)) {
    return artistInResidence;
  }
  return null;
};

function ProjectBadges({ badges }: Props) {
  return (
    <BadgeGrid>
      {badges.map((badge: string) => {
        const image = getBadgeImage(badge);
        return !image ? null : <Badge key={badge} src={image} alt={badge} />;
      })}
    </BadgeGrid>
  );
}
const BadgeGrid = styled.div({
  display: "grid",
  gap: "2rem 1rem",
  gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
  placeItems: "center start",
});
const Badge = styled.img({
  width: "100%",
  maxWidth: 140,
});

Badge.defaultProps = {
  onError: ({ currentTarget }: React.SyntheticEvent<HTMLImageElement>) => {
    currentTarget.style.display = "none";
  },
};

export { ProjectBadges };
